import { isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@env/environment';

const SETTINGS_STORAGE_KEY = 'IRMA_SETTINGS';

/**
 * En modo mock, siembra una sesión SYSTEM_ADMIN ya autenticada (si no hay ninguna) para que
 * el authGuard deje pasar directo a cualquier feature (ej. /dashboard?mock=true) sin pasar por
 * el login real de Microsoft/Firebase, que no puede mockearse vía MSW (requiere popup real).
 * No pisa una sesión ya existente.
 */
async function seedMockSession(): Promise<void> {
  const stored = localStorage.getItem(SETTINGS_STORAGE_KEY);
  const settings = stored ? JSON.parse(stored) : {};
  if (settings.authUser) return;

  const { mockAccount } = await import('./app/features/auth/tests/mocks/auth.msw');
  settings.authUser = mockAccount;
  localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(settings));
}

async function prepareApp() {
  const urlParams = new URLSearchParams(window.location.search);
  const isMockEnabled = isDevMode() && (urlParams.get('mock') === 'true' || localStorage.getItem('mock') === 'true');

  if (isMockEnabled) {
    const { worker } = await import('./mocks/browser');
    await seedMockSession();
    return worker.start({
      onUnhandledRequest: 'bypass',
    });
  }

  if (environment.mockDashboardApi) {
    const { dashboardWorker } = await import('./mocks/dashboard-browser');
    return dashboardWorker.start({
      onUnhandledRequest: 'bypass',
      quiet: true,
    });
  }
  return Promise.resolve();
}

prepareApp().then(() => {
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
});
